import React, { useState, Fragment, useEffect } from 'react';
import { motion } from 'framer-motion';
import { NextSeo } from 'next-seo';
import ContentSide from '../../components/blog/contentSide';
import InfoSide from '../../components/blog/infoSide';
import { withAnimation } from '../../utils/hoc';
import {
	getAllTags,
	getArticles,
	getArticlesCount,
	getHighlightedArticles
} from '@utils/contentfull';
import { useWidth } from '@utils/hooks/useWidth';
import { BREAK_POINTS } from '@utils/constants';
import Info from '@components/blog/info';
import logger from '@utils/logger';

const postVariants = {
	initial: { scale: 0.96, y: 30, opacity: 0 },
	enter: {
		scale: 1,
		y: 0,
		opacity: 1,
		transition: { duration: 0.5, ease: [0.48, 0.15, 0.25, 0.96] }
	},
	exit: {
		scale: 0.6,
		y: 100,
		opacity: 0,
		transition: { duration: 0.2, ease: [0.48, 0.15, 0.25, 0.96] }
	}
};

const BlogPage = ({
	articles,
	highlights,
	categories,
	articlesCount,
	limit,
	skip: skip,
	countArticle,
	tags,
	socials,
	admin
}) => {
	// set articles list state on render
	const [articlesList, setArticlesList] = useState(articles);
	const windowWidth = useWidth();

	const submitPagination = async (skip) => {
		const query = {
			tags,
			skip,
			limit
		};

		try {
			const articlesResponse = await getArticles(query);
			setArticlesList(articlesResponse);
			// setSkip(skip);
		} catch (error) {
			logger.log(error);
		}
	};

	useEffect(() => {
		setArticlesList(articles);
	}, [articles]);

	return (
		<>
			<NextSeo title="Blog" titleTemplate={`%s | ${admin.name}`} />
			<section className="section">
				<div className="container">
					<div className="columns">
						{windowWidth <= BREAK_POINTS.tablet && (
							<div className="column">
								<Info
									shortBio={admin.shortBio}
									image={admin.image}
									socials={socials}
								/>
							</div>
						)}

						<ContentSide
							articles={articlesList}
							articlesCount={articlesCount}
							limit={limit}
							skip={skip}
							countArticle={countArticle}
							onPageChanged={submitPagination}
						/>
						<InfoSide
							shortBio={admin.shortBio}
							image={admin.image}
							socials={socials}
							highlights={highlights}
							categories={categories}
						/>
					</div>
				</div>
			</section>
		</>
	);
};

BlogPage.getInitialProps = async (context) => {
	const {
		query: { tags = '', skip = '0', limit = '5' }
	} = context;

	// TODO: stop using query or make limitation
	// limitation to 12 articles per query
	if (limit > 12) limit = 12;

	const articles = await getArticles({ tags, skip, limit });

	const highlightedArticles = await getHighlightedArticles({ limit: 2 });
	const countArticle = await getArticlesCount({ tags });

	const allTags = await getAllTags();

	return {
		articles,
		articlesCount: countArticle,
		highlights: highlightedArticles,
		categories: allTags,
		limit: parseInt(limit) || 5, // default  5
		skip: parseInt(skip) || 0, // default  0
		tags
	};
};

export default withAnimation(BlogPage);
